const handler = (el, binding) => {
	const { observer, loaded } = binding.value;

	if (loaded) {
		el.classList.add('lazy-loaded');
		if (el.lazyObserver) {
			el.lazyObserver.unobserve(el);
			el.lazyObserver = undefined;
		}
	} else if (observer && !el.lazyObserver) {
		el.lazyObserver = observer;
		el.lazyObserver.observe(el);
	}
};

module.exports = {
	bind: handler,
	update: handler,
	unbind(el) {
		if (el.lazyObserver) {
			el.lazyObserver.unobserve(el);
		}
	}
};
